export default "__VITE_ASSET__BE0NT64X__"